export const HEAD_CELLS = [
  {
    id: 'fio',
    label: 'ФИО'
  },
  {
    id: 'role',
    label: 'Роль'
  },
  {
    id: 'branch',
    label: 'Филиал'
  },
  {
    id: 'tel',
    label: 'Номер телефона',
    sx: { whiteSpace: 'nowrap' }
  },
  {
    id: 'email',
    label: 'Email'
  },
  {
    id: 'status',
    label: 'Статус'
  },
  {
    id: 'actions',
    label: '',
    hideSortIcon: true
  }
];
